import React from "react";
import Myschedule from "./myschedule";
import ScheduleManage from "./schedulemanage";
import ScheduleMissed from "./scheduleMissed";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import AppBar from "@material-ui/core/AppBar";
import MiddleHeader from "../middleHeader/middleHeader";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import Popover from "@material-ui/core/Popover";
import Colors from "./../../Global/colors";
import {useTranslation} from 'react-i18next';

//Custom Css + Images
import "./schedule.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import dots from "../../Assets/dots.png";
import dotsH from "../../Assets/dotsH.png";
import search from "../../Assets/search.png";
import file from "../../Assets/file.png";
import share from "../../Assets/share.png";
import timetable from "../../Assets/timetable.png";
import add from "../../Assets/add.png";

//Redux
import { useSelector, useDispatch } from "react-redux";

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor:'#1a73e8'
    // display:'none'
  },
})(Tabs);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ backgroundColor: Colors.backgroundColor }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};





function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {
  const { t } = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const history = useHistory();
  const [mybtn, setbtn] = React.useState(false);
  const [permissions_obj, setPermissionObj] = React.useState({});
  const [value, setValue] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [packageDetails, setPackageDetails] = React.useState(null);
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu2, setFilterMenu2] = React.useState(null);

  let userData = useSelector((state) => state.userReducer.user);
let company = useSelector((state) => state.companyReducer.company);
React.useEffect(
  () => {
    getPermissions();
  },
  [company?.id]
);

React.useEffect(
  () => {
   if(window.location.pathname == "/schedule/missed"){
     setValue(2)
   }else if(window.location.pathname =="/schedule/manage/"){
    setValue(1)
   }else{
    setValue(0)
   }
  },
  []
);

console.log("________________________________*************________________________",window.location.pathname)

const handleClick3 = (event) => {
  setFilterMenu1(event.currentTarget);
};

const getPermissions = () => {
  console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let token = data?.token;
  if (data !== null) {
    let params = { company_id: company?.id, user_id: data?.user_id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.msg === "success") {
          let permissionsObj = {};
          await response.data.map((v) => {
            permissionsObj[(v?.title)] = true;
          });
          console.log("Permissions Obj >>>>>>>", permissionsObj);

          setPermissionObj(permissionsObj);

        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "jwt malformed" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          // console.log(status);
          if (status) {
            // console.log("opopopop");
            getPermissions();
          }
        }
      })
      .catch((error) => {
        // localStorage.clear();
        // window.location.replace("/signin");
        console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
      });
  }
};

  React.useEffect(() => {
    getPackageDetails();
  }, []);

    function handlePackage(e) {
    history.push(e);
  }

  console.log("packageDetails",packageDetails)


  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  }
  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (data.token == null) {
    return <Redirect to={"/signin"} />;
  }
  return <>
      <MiddleHeader />
      <div className="" style={{ width: "100%", padding: "20px", marginBottom: "0px", overflow: "auto", backgroundColor: "#eaf7fe" }}>
        <Grid justifyContent="center" alignItems="center" xs={12} sm={12} md={12} style={{ backgroundColor: "white", padding: "0px ", borderRadius: "5px", overflow: "hidden", boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)", marginBottom: "0px",height:'78vh', width: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ backgroundColor: "white", padding: " 5px 20px 0px", borderBottom: "1px solid #dadada", justifyContent: "space-between" }}>
            <Grid item xs={12} md={3}>
              <p className="label2" style={{ marginBottom: 0, marginTop: 0, fontSize: 14, color: Colors.globalColor8, fontWeight: "bolder", display: "block", textTransform: "uppercase" }}>
                {t("Create and Edit Schedule")}
              </p>
              {/* <p className="label2" style={{ marginBottom: 0, marginTop: 0, fontSize: 12, fontWeight: "normal", display: "block", color: "grey" }}>
                {packageDetails && packageDetails?.count + "/" + (packageDetails.data === "Unlimited" ? "~" : packageDetails.data) + " inspections have been created"}
              </p> */}
            </Grid>

            <Grid item xs={12} md={6}>
              {/* For Web */}
              {window.innerWidth > 700 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }} label={t("My Schedule")} {...a11yProps(0)} component={Link} to="/schedule" />
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black"}} label={t("Manage Schedule")} {...a11yProps(1)} component={Link} to="/schedule/manage/" />
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 2? Colors.globalColor9 : "transparent", color: value == 2 ? "#1a73e8" : "black" }} label={t("Missed Schedule")} {...a11yProps(2)} component={Link} to="/schedule/missed" />
                </AntTabs>}
              {/* For Tab */}
              {window.innerWidth > 500 && window.innerWidth <= 700 && <AntTabs className="scheduleTabHeader2" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="scheduleTab2" style={{ margin: "0px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? Colors.globalColor8 : "black" }} label={t("My Schedule")} {...a11yProps(0)} component={Link} to="/schedule" />
                  <Tab className="scheduleTab2" style={{ margin: "0px", textTransform: "uppercase", fontWeight: "bold", fontSize: 12, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? Colors.globalColor8 : "black" }} label={t("Manage Schedule")} {...a11yProps(1)} component={Link} to="/schedule/manage/" />
                  <Tab className="scheduleTab2" style={{ margin: "0px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? Colors.globalColor8 : "black" }} label={t("Missed Schedule")} {...a11yProps(2)} component={Link} to="/schedule/missed" />
                </AntTabs>}
              {/* For Mobile */}
              {window.innerWidth <= 500 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="scheduleTab3" style={{ margin: "0px", textTransform: "uppercase", fontSize: 10, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? Colors.globalColor8 : "black" }} label={t("My Schedule")} {...a11yProps(0)} component={Link} to="/schedule" />
                  <Tab className="scheduleTab3" style={{ margin: "0px", textTransform: "uppercase", fontWeight: "bold", fontSize: 10, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? Colors.globalColor8 : "black" }} label={t("Manage Schedule")} {...a11yProps(1)} component={Link} to="/schedule/manage/" />
                  <Tab className="scheduleTab3" style={{ margin: "0px", textTransform: "uppercase", fontSize: 10, fontWeight: "bold", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? Colors.globalColor8 : "black" }} label={t("Missed Schedule")} {...a11yProps(2)} component={Link} to="/schedule/missed" />
                </AntTabs>}
            </Grid>

            <Grid item xs={12} md={3} style={{ textAlign:language =="ar" ?"left" : "right", paddingBottom:"5px" }}>
              {packageDetails && <>
                  {" "}
                  {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Schedule Management"] == true ? <>
                      {packageDetails && (packageDetails?.inspection_limit != "Unlimited" ? parseInt(packageDetails.inspection_limit) > parseInt(packageDetails.inspection_count) : true) ? mybtn ? <Link to="#">
                            {" "}
                            <Button className="ctBtn" style={{ width: window.innerWidth < 700 && "100%" }}>
                              {t("Schedule Inspection")}
                            </Button>
                          </Link> : <Link to="/schedule-create">
                            {" "}
                            <Button className="ctBtn" style={{ width: window.innerWidth < 700 && "100%" }}>
                              {t("Schedule Inspection")}
                            </Button>
                          </Link> : <Button onClick={() => {
                            handlePackage("/update_package");
                          }} className="ctBtn" style={{ width:  window.innerWidth < 700 && "100%" }}>
                          {t("Upgrade Package")}
                        </Button>}
                    </> : <Button className="ctBtn2" style={{ width:  window.innerWidth < 700 && "100%"}}>
                      {t("Schedule Inspection")}
                    </Button>}
                </>}
            </Grid>
          </Grid>

          <div>
            <Switch>
              <Route exact path="/schedule/" component={Myschedule} />
              <Route exact path="/schedule/manage" component={ScheduleManage} />
              <Route exact path="/schedule/missed" component={ScheduleMissed} />
            </Switch>
          </div>
        </Grid>
      </div>
    </>;
}
